import React from "react";

interface TimeStepsControlProps {
  numTimeSteps: number;
  onNumTimeStepsChange: (value: number) => void;
}

const TimeStepsControl: React.FC<TimeStepsControlProps> = ({
  numTimeSteps,
  onNumTimeStepsChange,
}) => {
  return (
    <div style={{
      padding: "16px",
      borderBottom: "1px solid #e0e0e0",
      background: "#fafafa",
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
      }}>
        <label style={{
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
        }}>
          Time Steps:
        </label>
        <input
          type="range"
          min="1"
          max="24"
          value={numTimeSteps}
          onChange={(e) => onNumTimeStepsChange(Number(e.target.value))}
          style={{
            flex: 1,
            cursor: "pointer",
          }}
        />
        <span style={{
          fontSize: "14px",
          fontWeight: "bold",
          color: "#2196F3",
          minWidth: "30px",
          textAlign: "right",
        }}>
          {numTimeSteps}
        </span>
      </div>
      <div style={{
        marginTop: "8px",
        fontSize: "12px",
        color: "#666",
      }}>
        Adjust the number of time steps for the multi-timestep optimization (1-24 hours)
      </div>
    </div>
  );
};

export default TimeStepsControl;